import { Profile } from 'model/modules/profile/profile';
import moment from 'moment';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapBrokerTypeFromApi from 'rtkQuery/sharespro/mapper/shared/mapBrokerTypeFromApi';

const mapProfileFromApi = (
  resp: SharesproApiResponse<ApiProfileResponseData>
): Profile => {
  return {
    email: resp.data.email,
    phone: resp.data.phone,
    firstName: resp.data.first_name,
    lastName: resp.data.last_name,
    secondName: resp.data.second_name,
    gender: resp.data.gender,
    birthday: resp.data.birth_day
      ? moment(resp.data.birth_day, 'DD.MM.YYYY').toDate()
      : null,
    avatar: resp.data.avatar,
    brokerAccounts: resp.data.broker_accounts.map((account) => ({
      id: account.id,
      brokerType: mapBrokerTypeFromApi(account.broker_id),
      brokerLogin: account.broker_login,
      account: account.account,
      balance: account.balance,
      isSelected: account.selected,
      status: account.status,
      accountId: account.ext_id,
    })),
    isPrivateChannelAllowed: resp.data.is_private_channel_allowed,
    isTelegramConnected: resp.data.is_telegram_connected,
  };
};

export default mapProfileFromApi;
